import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import _ from 'lodash';

import { FEATURES } from 'src/app/constants';
import { WebhookConfig, WebhookSubscription } from 'src/models';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';
import { TenantsService } from 'src/services/tenants.service';
import { WebhookSubscriptionsService } from 'src/services/webhook-subscriptions.service';

@Component({
  selector: 'app-admin-webhooks',
  templateUrl: './admin-webhooks.component.html',
  styleUrls: ['./admin-webhooks.component.scss'],
})
export class AdminWebhooksComponent implements OnInit {
  forwardEmail: string;
  webhookConfig: Partial<WebhookConfig>;
  webhookSubscriptions: Partial<WebhookSubscription>[];
  featureEnabled = true;
  signingSecretShown = false;

  constructor(
    public authService: AuthService,
    private msgSrvc: MessageService,
    private alertCtrl: AlertController,
    private tenantsService: TenantsService,
    private webhookSubsciptionsService: WebhookSubscriptionsService,
  ) {}

  async ngOnInit() {
    this.featureEnabled = !this.authService.restrictedFeatures.includes(FEATURES.WEBHOOKS);

    await Promise.all([this.getWebhookConfig(), this.getWebhookSubscriptions()]);
  }

  async getWebhookConfig() {
    const result = await this.tenantsService.getWebhookConfig();

    this.webhookConfig = result;
  }

  async getWebhookSubscriptions() {
    const result = await this.webhookSubsciptionsService.listAll();

    this.webhookSubscriptions = result;

    if (!this.webhookSubscriptions.length) {
      this.addWebhookSubscription();
    }
  }

  addWebhookSubscription() {
    this.webhookSubscriptions.push({
      url: '',
      enabled: true,
    });
  }

  async save(index: number) {
    try {
      const payload: Partial<WebhookSubscription> = this.webhookSubscriptions[index];

      payload?.id
        ? await this.webhookSubsciptionsService.updatePartial(payload.id, payload)
        : await this.webhookSubsciptionsService.create(payload);

      this.getWebhookSubscriptions();

      this.msgSrvc.show('✔︎ Saved');
    } catch (e) {
      this.msgSrvc.showError(e);
    }
  }

  async delete(index: number) {
    if (!this.webhookSubscriptions[index].id) {
      this.webhookSubscriptions.pop();
      return;
    }

    const alert = await this.alertCtrl.create({
      header: 'Delete webhook subscription',
      subHeader: 'Are you sure you want to delete this webhook subscription?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: async () => {
            if (this.webhookSubscriptions[index]) {
              await this.webhookSubsciptionsService.delete(this.webhookSubscriptions[index].id);

              this.getWebhookSubscriptions();
            }
          },
        },
      ],
    });

    await alert.present();
  }

  toggleSigningSecret() {
    this.signingSecretShown = !this.signingSecretShown;
  }

  showWebhookHelpdesk() {
    window.open('https://docs.unthread.io/api-introduction/webhooks', '_blank');
  }
}
